module.exports = "images/apple-icon-72x72.175f3ad03286503fcd77cc03bd3c6451.png";